/* src/app/components/doc-viewer-new/form-controls/edit-date-input/edit-date-input.component.scss */
.datepicker-container {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin: 0px 6px 0px 3px;
}
.datepicker-container button {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}
.action-icon {
  color: rgb(36, 62, 144);
  background-color: inherit;
}
.icon-alternate {
  color: inherit;
}
input {
  background-color: rgba(252, 252, 252, 0.6862745098);
  border: 1px solid #243e90;
  border-radius: 5px;
  padding: 8px;
  outline: none;
  color: inherit;
  background: inherit;
  transition: box-shadow 0.2s;
}
input:focus {
  background-color: rgba(252, 252, 252, 0.6862745098);
  border-color: #283593;
  box-shadow: 0 0 3px rgba(40, 52, 147, 0.6862745098);
}
:host-context(.dark-theme) input {
  border: 1px solid rgba(255, 255, 255, 0.1882352941);
  border-radius: 5px;
  padding: 8px;
  outline: none;
  color: inherit;
  background: inherit;
  transition: box-shadow 0.2s;
}
:host-context(.dark-theme) input:focus {
  border-color: #D0A010;
  box-shadow: 0 0 3px #b18a16;
}
:host-context(.dark-theme) .action-icon {
  color: rgb(255, 193, 7);
}
/*# sourceMappingURL=edit-date-input.component.css.map */
